export default {
  mounted() {
    this.open();
  },
  beforeDestroy() {
    this.releaseScrollLock();
  },
  methods: {
    open() {
      this.$root.$el.style['overflow-y'] = 'hidden';
      this.$root.$el.style.height = '100vh';
    },
    releaseScrollLock() {
      if (!this.$root || !this.$root.$el) return;

      this.$root.$el.style['overflow-y'] = '';
      this.$root.$el.style.height = '';
    },
    close(redirectTo, shouldFetchReport) {
      this.releaseScrollLock();
      this.$emit('close', redirectTo, shouldFetchReport);
    },
  },
};
